module.exports = __WEBPACK_EXTERNAL_MODULE_yejP__;


//////////////////
// WEBPACK FOOTER
// external "ui-bootstrap4"
// module id = yejP
// module chunks = 0